import { useState } from 'react';
import { faPizzaSlice } from '@fortawesome/free-solid-svg-icons';
import { faSquare as faSquareRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NavTabs from './NavTabs';
import HeaderControls from './HeaderControls';
import SettingsOverlay from '../SettingsOverlay';

function Brand() {
  return (
    <span className="flex items-center gap-2 py-2 select-none">
      <span className="fa-stack text-base leading-none text-[color:var(--app-brand)]">
        <FontAwesomeIcon icon={faSquareRegular} className="fa-stack-2x" />
        <FontAwesomeIcon icon={faPizzaSlice} className="fa-stack-1x" />
      </span>
      <span className="hidden text-base font-bold tracking-tight sm:inline">Pizza Belag</span>
    </span>
  );
}

function AppHeader() {
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-30 border-b border-[color:var(--app-border)] bg-[color:var(--app-surface)]">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 sm:px-6">
        <Brand />
        <NavTabs />
        <HeaderControls onOpenSettings={() => setSettingsOpen(true)} />
      </div>
      <SettingsOverlay open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </header>
  );
}

export default AppHeader;